import {Navigate, useLocation} from "react-router-dom";
import React, {PropsWithChildren} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";

export type RequireAuthProps = PropsWithChildren<NonNullable<unknown>>;

export const RequireAuth = (props: RequireAuthProps) => {
  const {children} = props;

  const auth = useAuth();
  const location = useLocation();

  if (!auth || !auth.authenticated) {
    console.log("Redirecting to login");
    return <Navigate to="/login" state={{from: location}} replace/>;
  }

  return children;
};
